/**
 * Protected app layout
 * All routes under /app require authentication
 */

'use client';

import { AppNav } from '@/components/app/AppNav';
import { QueryProvider } from '@/components/providers/QueryProvider';
import { OfflineIndicator } from '@/components/OfflineIndicator';

export default function AppLayout({ children }: { children: React.ReactNode }) {
  // For personal use: guest mode - no auth required
  const guestUser = { id: 'guest', email: 'guest@local', name: 'Guest' };

  return (
    <QueryProvider>
      <div className="min-h-screen flex flex-col">
        <AppNav user={guestUser} />
        <main className="flex-1 px-3 sm:px-4 md:px-6 lg:px-8 py-4 sm:py-6 md:py-8 lg:py-12 max-w-7xl mx-auto w-full overflow-x-hidden">
          {children}
        </main>
        <OfflineIndicator />
      </div>
    </QueryProvider>
  );
}
